import { EffectCallback, useEffect, useRef } from 'react';

export function useEffectOnce(effect: EffectCallback) {
  const ref = useRef(false);

  useEffect(() => {
    if (ref.current) {
      return;
    }

    ref.current = true;

    return effect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
